// Constants for the application
import { expo } from "maath/dist/declarations/src/easing";
import { Vector3 } from "three";
import Donation from "../types/Donation";
import ZoneOption from "../types/ZoneOption";

export const BASE_URL = window.location.hostname === "buyabrick.firstunited.ca" ? "https://api-buyabrick.firstunited.ca" : "http://localhost:3000";

export const DEFAULT_DONATION: Donation = {
  amount: 5000,
  payment_status: "pending",
  brick_zone: null,
  brick_colour: null,
};

export const DEFAULT_CAMERA_SETTINGS = {
  fov: 45, // deg
  near: 0.01, // near and far will help performance, but watch for clipping
  // far: 200,
  position: new Vector3(10, 10, 10), // default position
  // rotation: new Vector3(-0.7854, 0.6155, 0.5236),
  target: new Vector3(0, 0, 0),
  zoom: 4,
  zoomMobile: 4,
};

// Zones Options
export const ZONES: ZoneOption[] = [
  {
    label: "North Deck Wall",
    value: "north",
    position: new Vector3(0.55, -0.27, 1.3),
    target: new Vector3(0.55, -0.27, 1),
    zoom: 0.3,
    zoomMobile: 0.4,
  },
  {
    label: "South Deck Wall",
    value: "south",
    position: new Vector3(0.55, -0.27, 0.2),
    target: new Vector3(0.55, -0.27, 0.6),
    zoom: 0.3,
    zoomMobile: 0.4,
  },
  {
    label: "Lightwell Wall",
    value: "light_well",
    position: new Vector3(4.4, 0.2, 0),
    target: new Vector3(1.5, 0.2, 0),
    zoom: 1.1,
    zoomMobile: 1.1,
  },
];

export const BRICK_COLOURS: {
  label: string;
  value: string;
  color: string;
}[] = [
  {
    label: "White",
    value: "white",
    // color: "#FFF",
    color: "#FAF5F4",
  },
  {
    label: "Yellow",
    value: "yellow",
    // color: "#E1BF83",
    // color: "#E1B37D",
    color: "#FFBC5D",
  },
  {
    label: "Red",
    value: "red",
    // color: "#954A4A",
    // color: "#7B443E",
    color: "#BD2222",
  },
  {
    label: "Black",
    value: "black",
    // color: "#414141",
    color: "#323B46",
    // color: "#D6D6D6",
  },
];

// Dedication Options
export const DEDICATION_OPTIONS = [
  {
    label: "No Dedication",
    value: "none",
  },
  {
    label: "In Honour of",
    value: "in_honour",
  },
  {
    label: "In Memory of",
    value: "in_memory",
  },
];

export const REASON_PROVIDES_OPTIONS = ["dignity", "belonging", "justice", "essential services", "healing"];

export const REASON_WHO_OPTIONS = ["are our neighbours", "experience poverty", "experience homelessness", "deserve compassion"];

function sample<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

// Boost Amounts
export const BOOST_AMOUNTS = [9000, 14000, 25000, "custom"];

// TEMP DATA
export const TEMP_GOLDEN_DONORS: Donation[] = [
  {
    id: 51,
    recognition_name_display: "Karen Giesbrecht",
    brick_zone: "north",
    brick_colour: "yellow",
    brick_level: 1,
    reason_provides: "belonging",
    reason_who: "are our neighbours",
    dedication: "in_memory",
    dedication_name: "Betty",
    amount: 5000,
    payment_status: "succeeded",
  },
  {
    id: 140,
    recognition_name_display: "Dr V Cheryl Lee",
    brick_zone: "north",
    brick_colour: "black",
    brick_level: 1,
    reason_provides: "essential services",
    reason_who: "are our neighbours",
    dedication: "in_honour",
    dedication_name: "Kenji Quinton Lee",
    amount: 5000,
    payment_status: "succeeded",
  },
  {
    id: 320,
    recognition_name_display: "Hans Gust",
    brick_zone: "south",
    brick_colour: "black",
    brick_level: 1,
    reason_provides: null,
    reason_who: null,
    dedication: null,
    dedication_name: null,
    amount: 5000,
    payment_status: "succeeded",
  },
  {
    id: 501,
    recognition_name_display: "Sharon and Bob Copeman",
    brick_zone: "south",
    brick_colour: "black",
    brick_level: 1,
    reason_provides: null,
    reason_who: null,
    dedication: "in_honour",
    dedication_name: "Caleigh Grunert",
    amount: 5000,
    payment_status: "succeeded",
  },
  {
    id: 1000,
    recognition_name_display: "Colin Hearty",
    brick_zone: "light_well",
    brick_colour: "black",
    brick_level: 2,
    reason_provides: null,
    reason_who: null,
    dedication: null,
    dedication_name: null,
    amount: 9000,
    payment_status: "succeeded",
  },
];

export const TEMP_CORPORATE_DONORS: Donation[] = [
  {
    id: 1,
    recognition_name_display: "Denim and Steel",
    brick_zone: "north",
    brick_colour: "yellow",
    brick_level: 3,
    reason_provides: "healing",
    reason_who: "are our neighbours",
    logoUrl: "denimsteel",
    amount: 40000,
    payment_status: "succeeded",
    donorLinkUrl: "https://denimandsteel.com",
    donorLinkText: "denimandsteel.com",
  },
  {
    id: 2,
    recognition_name_display: "CC&L Infrastructure",
    brick_zone: "north",
    brick_colour: "yellow",
    brick_level: 3,
    reason_provides: "essential services",
    reason_who: "are our neighbours",
    logoUrl: "cclinfrastructure",
    amount: 40000,
    payment_status: "succeeded",
    donorLinkUrl: "https://cclinfrastructure.cclgroup.com/",
    donorLinkText: "cclinfrastructure.cclgroup.com",
  },
];

import audain from "../../assets/logos/audain-white.svg";

export const TEMP_LEADERSHIP_DONORS: Donation[] = [
  {
    id: 1,
    recognition_name_display: "Audain Foundation",
    brick_zone: "north",
    brick_colour: "yellow",
    brick_level: 3,
    logoUrl: audain,
    amount: 40000,
    payment_status: "succeeded",
    reason_provides: "belonging",
    reason_who: "deserve compassion",
    leadership_details: {
      partner_type: "PUBLIC ART",
      description:
        "The Audain Foundation was founded by Michael Audain and Yoshiko Karasawa in 1997. The Foundation provides grants and endowments for visual art exhibitions, education and capital projects in British Columbia. Their incredibly generous $1 million contribution will support the creation of Salish art by Host Nation artists on our building’s exterior and help make public art more accessible in the Downtown Eastside.",
      extra_link: "",
    },
  },
  {
    id: 2,
    recognition_name_display: "Rudy and Elizabeth Kerklaan",
    brick_zone: "north",
    brick_colour: "yellow",
    brick_level: 3,
    logoUrl: "",
    amount: 40000,
    payment_status: "succeeded",
    reason_provides: "dignity",
    reason_who: "are our neighbours",
    leadership_details: {
      partner_type: "BUY-A-BRICK MATCHING",
      description:
        "Rudy and Elizabeth Kerklaan have been long-time supporters of FIRST UNITED. Over the years, they’ve dedicated time as volunteers and have witnessed the pain and struggle as well as the strength and possibility of this community. They hope the Buy-a-Brick triple match will inspire others to learn more about the important issues people face in the Downtown Eastside AND, with openness and compassion, to get involved.",
      extra_link: "",
    },
  },
];

import denimsteel from "../../assets/logos/denimsteel.png";
import cclinfrastructure from "../../assets/logos/cclinfrastructure.png";

export const CORP_LOGOS: Record<string, string> = {
  denimsteel,
  cclinfrastructure,
};
